import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UserStorage } from "../user/user-storage";
/**
 * Api is a generic REST Api handler. Set your API url first.
 */
@Injectable()
export class ApiNew {
  public api: string = "api/v1";
  public url: string = null;

  constructor(private http: HttpClient, private userStorage: UserStorage) {}

  setUrl(url: string) {
    this.url = url + this.api;
  }

  checkUrl(): Observable<any> {
    return Observable.create(observable => {
      if (!this.url) {
        const storageUrl = this.userStorage.API_URL;
        if (storageUrl) {
          this.setUrl(storageUrl);
        } else {
          observable.error("Error when load url");
        }
      }
      observable.next(this.url);
    });
  }

  getAll(endpoint: string, params?: any) {
    return this.checkUrl().flatMap(res =>
      this.http.get(this.url + "/" + endpoint, { params: params })
    );
  }

  getOne(endpoint: string, id: string) {
    return this.checkUrl().flatMap(res =>
      this.http.get(this.url + "/" + endpoint + "/" + id)
    );
  }

  post(endpoint: string, data: any) {
    return this.checkUrl().flatMap(res =>
      this.http.post(this.url + "/" + endpoint, data)
    );
  }

  put(endpoint: string, id: string, data?: any) {
    return this.checkUrl().flatMap(res =>
      this.http.put(this.url + "/" + endpoint + "/" + id, data)
    );
  }

  delete(endpoint: string, id) {
    return this.checkUrl().flatMap(res =>
      this.http.delete(this.url + "/" + endpoint + "/" + id)
    );
  }

  patch(endpoint: string, body: any, reqOpts?: any) {
    return this.checkUrl().flatMap(res =>
      this.http.patch(this.url + "/" + endpoint, body, reqOpts)
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/api/api-new.ts